// Errors Mutations

export const setErrorsList = (state, payload) => {
  state.errorsList = payload
}

export const resetErrorsList = state => {
  state.errorsList = []
}

export const resetValidationErrors = (state, payload) => {
  state.resetValidationErrors = payload
}
